import { useFetch } from '../../hooks/useFetch';

/**
 * @param {import('../../types/dashboard').DashboardRefreshParams} [params]
 * @returns {Promise<import('../../types/dashboard').DashboardInventory>}
 */
export const FetchDashboardInventory = async (params) => {
  const body = await useFetch('/dashboard/inventory', params);

  return body.data;
};
